import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { AddStationAction } from "stores/AddStationStore/addStationAction";
import { chargingStationActions } from "stores/ChargingStationStore/chargingStationAction";
import { commonActions } from "stores/common/commonActions";

const mapStateToProps = (state) => {
  return {
    chargingStationData: state.chargingStation.chargingStationList,
    isLoading: state.chargingStation.chargingStation.isLoading,
    amenitiesData: state.common.amenitiesData,
    getChargingPointData: state.chargingStation.chargingPointList,
    profile: state.login.userProfile,
    chargerTypes: state.common.chargerTypes,
    VendorSelectWiseList: state.chargingStation.VendorSelectWiseList,
    ChargingStationCountList: state.chargingStation.ChargingStationCountList,
    ChargingConnectorDropdownList:
      state.chargingStation.ChargingConnectorDropdownList,
    addstation: state.AddStationReducers.addstation,
    networkData: state.common.networkData,
    chargingStationNetwork:
      state.chargingStation.chargingStationNetwork,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      postaddstations: AddStationAction.postAddStation,
      getChargingStationsAction: chargingStationActions.getChargingStations,
      deleteChargingStationAction: chargingStationActions.deleteChargingStation,
      getAmenitiesAction: commonActions.getAmenitiesData,
      getNetworkAction: commonActions.getNetworkData,
      chargerTypeAction: commonActions.chargerTypeAction,
      getChargingPointAction: chargingStationActions.getChargingPoint,
      deleteChargingConnectorAction:
        chargingStationActions.deleteChargingConnectorActions,
      getVendorSelectWiseAction:
        chargingStationActions.getVendorSelectWiseAction,
      getChargingStationCountAction:
        chargingStationActions.getChargingStationCount,
      getChargingConnectorDropdownAction:
        chargingStationActions.getChargingConnectorDropdown,
      getChargingNetworDropdownAction:chargingStationActions.getChargingNetworkDropdown
    },
    dispatch
  );

const ChargingStationStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default ChargingStationStore;
